import React, { Component } from 'react';
import Sidebar from '../../Common/Sidebar/Sidebar'
import UsersTable from './UsersTable'
import * as userServices from '../../services/userService'
import Loader from "react-loader-spinner";
class Users extends Component {
    state = { 
        newUser: false,
        newUserData:{
           name:"",
           email:"",
           password:"",
           group_id:""  
        },
        successful: false,
        failed:false,
        user:{},
        isLoading:true,
        isRegistering:false,
        errorMessage:"",
        successMessage:"",
        listOfUsers:[],
        listOfUsersGroups:[],
        isInitiallyLoaded:true
    }
    async componentDidMount () {
        let loggedInUser = localStorage.getItem('currentUser')
        let usersResponse = await userServices.getAllUsers()
        let usersGroupResponse = await userServices.getAllUsersGroups()
        let listOfUsersGroups = await usersGroupResponse.data
        let listOfUsers = await usersResponse.data
        loggedInUser = JSON.parse(loggedInUser)
        this.setState({user:loggedInUser})
        this.setState({ listOfUsers })
        this.setState({isLoading:false})
        this.setState({listOfUsersGroups})
        this.setState({isInitiallyLoaded:false})
     };
    closeAdd= () => {
        this.setState ({newUser: false})
    }
    openAdd = () => {
        this.setState({newUser: true})
    }
    handleUserName =(event) =>{
        let newUserData = { ...this.state.newUserData}
        newUserData.name = event.target.value
        this.setState({newUserData})
    }
    handleUserEmail =(event) =>{
        let newUserData = { ...this.state.newUserData}
        newUserData.email = event.target.value
        this.setState({newUserData})
    }
    handleUserPassword =(event) =>{
        let newUserData = { ...this.state.newUserData}
        newUserData.password = event.target.value
        this.setState({newUserData})
    }
    handleGroupChange = (event) =>{
        let newUserData = { ...this.state.newUserData}
        newUserData.group_id = event.target.value
        this.setState({newUserData})
    }
    handleSaveNewUser= async(e) =>{
      try {
          e.preventDefault()
          this.setState({isRegistering:true})
        let response = await userServices.addNewUser(this.state.newUserData)
        if(response.status === 201){
           this.setState({successMessage:response.data.message})
           this.setState ({newUser: false})
           this.setState({isRegistering:false})
           window.location.reload(false)
        }
    } catch (error) {
       this.setState({isRegistering:false})
       this.setState({errorMessage:error.response.data.message})   
       this.setState({failed:true})       
      }
        
    }
    closeSuccessful = () =>{
        this.setState({successful: false})
    }
    closeFailed = () =>{
        this.setState({failed: false})
    }
    render() { 
        let { user } = this.state
        return ( 
            this.state.isInitiallyLoaded ?
            <div className="flex justify-center items-center h-screen">
                    <Loader type="Oval" className="align-middle" color="#F35D2D" height={100} width={100}/>
            </div> 
            :
            <div className="flex flex-row w-full">
            <div className=" p-4 bg-white md:h-screen fixed w-60">
                <Sidebar user={user}/>
            </div>
            <div className="py-8 px-8 ml-60 w-full">
                 <div className="h-full  bg-white rounded-md">
                 <div className=" flex justify-between p-8">
                    <span className="font-bold text-base">
                        List of all users
                    </span>
                    {/* if Auth User is Administration */}
                     {
                         user.is_admin &&
                         <button class="bg-wvrblue text-white text-xs px-3 py-2 rounded-md" onClick={() => this.openAdd()}>New User</button>
                     }
                    {/* Endif */}
                 </div>
                     <div class="ml-8">
                         {/* <UsersTable listOfUsers = {this.state.listOfUsers}/> */}
                         {!this.state.isLoading &&  <UsersTable listOfUsers = {this.state.listOfUsers}/>}                            
                         {this.state.isLoading && 
                     <div className = "px-auto flex justify-center items-center">
                       <p className = "font-bold text-center text-red-500">Fetching Users...</p>
                                <Loader
                                type="Puff"
                                color="#F35D2D"
                                height={50}
                                className="ml-4"
                                width={50} />
                     </div>
                    }
                     </div>
                     {
                        this.state.newUser && (
                            <div className=" w-screen fixed top-0 left-0 h-screen  z-10">
                            <div className="flex flex-col my-4 border-black py-4 px-10 bg-white absolute z-50 bottom-8 left-96 right-96 border-2">
                                <div className="flex flex-col my-4 text-wvrDarkPrimary">
                                    <p className="font-bold text-left">Add New User</p>
                                    <form onSubmit={this.handleSaveNewUser}>
                                    <div className="flex flex-row w-full gap-8 py-2">
                                            <div className="w-1/2 flex flex-col">
                                                <label className="text-sm mb-1">
                                                    User Names
                                                </label>
                                                <input type="text" onChange={this.handleUserName} value={this.state.newUserData.name} name="" placeholder="Fill in the field" className=" text-xs p-2 border-2 border-wvrPrimary rounded-md "/>
                                            </div>
                                            <div className="w-1/2 flex flex-col">
                                                <label className="text-sm mb-1">
                                                  User Email
                                                </label>
                                                <input type="email" onChange={this.handleUserEmail} value={this.state.newUserData.email} name="" id="" placeholder="Fill in the field" className="text-xs p-2 border-2 border-wvrPrimary rounded-md "/>
                                            </div>
                                        </div>
                                        <div className="flex flex-row w-full gap-8 my-4">
                                        <div className="w-1/2 flex flex-col">
                                                <label className="text-sm mb-1">
                                                   Department Group
                                                </label>
                                                <select onChange={this.handleGroupChange} name="" id="" className="text-xs p-2 border-2 border-wvrPrimary rounded-md ">
                                                    <option value="" selected disabled>select Department</option>
                                                    {
                                                        this.state.listOfUsersGroups.map(group=>{
                                                            return(
                                                                <option key={group.id} value={group.id}>{group.display_name}</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        <div className="w-1/2 flex flex-col">
                                                <label className="text-sm mb-1">
                                                  User Password
                                                </label>
                                                <input onChange={this.handleUserPassword} value={this.state.newUserData.password} type="password" name="" id="" placeholder="Fill in the field" className="text-xs p-2 border-2 border-wvrPrimary rounded-md "/>
                                            </div>
                                        </div>
                                        
                                        
                                        <div className="flex flex-row gap-4 my-4">
                                            {
                                                !this.state.isRegistering ?
                                                <button className="bg-wvrblue text-white py-2 px-8 rounded-md">Register</button>:
                                                <button className="bg-blue-300 text-white py-2 px-8 rounded-md">Please Wait...</button>
                                            }
                                            <button className="bg-wvrPrimary py-2 px-8 rounded-md" onClick={() => this.closeAdd ()}>cancel</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            </div>
                        )
                     }
                     {
                         this.state.successful && (
                            <div className="fixed top-8 right-0 bg-wvrLightGreen w-72 text-xs z-20 border-2 border-wvrGreen rounded-md">
                                <div className="flex flex-row py-2 px-4 gap-4">
                                    <div className=" bg-wvrGreen p-1 rounded-md">
                                        <div className="bg-white rounded-full p-1">
                                            <p className="text-wvrGreen"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg></p>
                                        </div>
                                    </div>
                                    <div className="flex items-center">
                                        <p>{this.state.successMessage}</p>
                                    </div>
                                    <button className=" flex items-center" onClick={() => this.closeSuccessful ()}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                                    </button>
                                </div>
                             </div>
                         )
                     }
                      {
                         this.state.failed && (
                            <div className="fixed top-8 right-0 bg-red-500 w-80 text-xs z-20 border-2 border-red-800 rounded-md">
                            <div className="flex flex-row py-2 px-4 gap-4">
                                <div className=" bg-red-500 p-1 rounded-md">
                                    <div className="bg-white rounded-full p-1">
                                        <p className=""><svg className="w-5 h-5 cursor-pointer text-red-500" onClick={() => this.closeFailed ()} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" /></svg></p>
                                    </div>
                                </div>
                                <div className="flex items-center">
                                    <p className="text-white">{this.state.errorMessage}</p>
                                </div>
                            </div>
                         </div>
                         )
                     }
                </div>
            </div>
        </div>
         );
    }
}
 
export default Users;